import React from 'react';
import { useDispatch } from 'react-redux';
import { 
  Container,
  AnimationContainer,
  Title,
  ButtonClose,
  MessageContainer,
  Message,
} from './styles';

import { openShowModal } from '../../store/modules/parameter/actions';
import { config } from '../../config';

interface AlertModal {
 message?: string
}

const AlertModal: React.FC<AlertModal> = ({
  message = `Produtos vendidos por quilo (kg) podem apresentar variação no valor final, 
  conforme o peso real calculado durante a separação.\n\n
O valor será ajustado automaticamente após a separação da compra.`,
}: AlertModal) => {
  const dispatch = useDispatch();
  return (
    <Container widthImg={config.image.width}>
        <img src={config.logo_alert_message} alt="ConectoVarejo" />
            <AnimationContainer>
        <MessageContainer>
            <Title>ATENÇÃO</Title>

            <Message id="message-alert-modal">{message}</Message>
        </MessageContainer>

        <ButtonClose
          id="button-action-close-alert-modal"
          onClick={() => {
          dispatch(openShowModal(false));
        }}>Fechar aviso</ButtonClose>
      </AnimationContainer>
    </Container>
  );
};

export default AlertModal;
